function getToolsInfoCompleteState(to, from) {
  cleanExpiredVisitRecords();
  if (to.meta.isNeedShowInfoComplete || to.path.includes('formula/evaluation') || to.path.includes('formula/treatment')) {
    // 需要进行完善信息弹窗的页面
    return checkAndCountPageVisit(to);
  }
  return false;
}

function getTNMDetailInfoCompleteState() {
  let to = {}
  to.name = "tnmDetail"
  return checkAndCountPageVisit(to);
}

/**
 * 获取当前用户ID
 * @returns {string} 用户ID
 */
function getCurrentUserId() {
  let userId = '';
  
  // 尝试从 sessionStorage 获取用户信息
  try {
    const userInfoStr = localStorage.getItem('userinfoobjstr');
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr);
      if (userInfo && userInfo.userid) {
        userId = userInfo.userid;
        console.log('userInfo.userid', userId)
        return userId;
      }
    }
  } catch (error) {
    console.warn('获取用户信息失败:', error);
  }
  
  // 尝试从 sessionStorage 获取 userId
  const sessionUserId = sessionStorage.getItem('userId');
  if (sessionUserId) {
    userId = sessionUserId;
    console.log('sessionUserId', userId)
    return userId;
  }
  
  // 使用匿名ID作为备选
  const anonymousId = localStorage.getItem('AnonymousID');
  if (anonymousId) {
    userId = anonymousId;
    console.log('anonymousId', userId)
    return userId;
  }
  
  return 'guest'; // 默认访客ID
}

/**
 * 检查并计数页面访问，判断是否需要弹窗
 * @param {Object} to - 路由对象
 * @returns {boolean} 是否需要弹窗
 */
function checkAndCountPageVisit(to) {
  // 获取当前用户ID
  const userId = getCurrentUserId();
  
  // 获取当前日期作为key
  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD格式
  
  // 确定页面类别
  let pageCategory;
  if (to.path && to.path.includes('formula')) {
    pageCategory = 'formula';
  } else {
    pageCategory = to.name || 'unknown';
  }
  
  // 从本地存储获取今日用户弹窗记录
  const storageKey = `user_popup_${today}`;
  let todayPopups = {};
  
  try {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      todayPopups = JSON.parse(stored);
    }
  } catch (error) {
    console.warn('读取弹窗记录失败:', error);
    todayPopups = {};
  }
  
  // 初始化当前用户的记录
  if (!todayPopups[userId]) {
    todayPopups[userId] = {
      hasPopup: false, // 今天是否已经弹窗
      visitCounts: {} // 各页面访问计数
    };
  }
  
  // 初始化当前页面类别的计数
  if (!todayPopups[userId].visitCounts[pageCategory]) {
    todayPopups[userId].visitCounts[pageCategory] = 0;
  }
  
  // 增加访问计数
  todayPopups[userId].visitCounts[pageCategory]++;
  
  // 获取弹窗阈值
  const popupThresholds = getPopupThresholds();
  const threshold = popupThresholds[pageCategory] || popupThresholds.default;
  
  // 判断是否需要弹窗：用户今天未弹窗 且 当前页面访问次数达到阈值
  const currentCount = todayPopups[userId].visitCounts[pageCategory];
  const hasPopupToday = todayPopups[userId].hasPopup;
  const shouldPopup = !hasPopupToday && currentCount >= threshold;
  
  if (shouldPopup) {
    // 标记用户今天已弹窗
    todayPopups[userId].hasPopup = true;
  }
  
  // 保存到本地存储
  try {
    localStorage.setItem(storageKey, JSON.stringify(todayPopups));
  } catch (error) {
    console.warn('保存弹窗记录失败:', error);
  }
  
  return shouldPopup;
}

/**
 * 获取不同页面类别的弹窗阈值配置
 * @returns {Object} 阈值配置对象
 */
function getPopupThresholds() {
  return {
    formula: 3,        // formula页面访问3次弹窗一次
    default: 2,        // 其他页面默认2次弹窗一次
    TrjDetail: 1,
    tnmDetail: 3,
    // 可以根据具体页面名称设置不同阈值
    // 'page-name': 10,
  };
}

/**
 * 清理过期的访问记录（可选，用于定期清理本地存储）
 */
function cleanExpiredVisitRecords() {
  const today = new Date().toISOString().split('T')[0];
  
  // 清理2天前的记录
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('user_popup_')) {
      const dateStr = key.replace('user_popup_', '');
      const recordDate = new Date(dateStr);
      const daysDiff = (new Date(today) - recordDate) / (1000 * 60 * 60 * 24);
      
      if (daysDiff > 2) {
        localStorage.removeItem(key);
        i--; // 因为删除了一个项目，需要调整索引
      }
    }
  }
}

export default getToolsInfoCompleteState;
export { getTNMDetailInfoCompleteState };
